/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
export enum Timezone {
  GMT_0 = 'GMT-00:00'
}
